import 'moment/locale/pt';

import { ICycle } from 'models/cycle/cycle.model';
import { IMonthOption } from 'models/option/option.model';
import moment from 'moment';

moment.updateLocale('pt', {
	months: [
		'Janeiro',
		'Fevereiro',
		'Março',
		'Abril',
		'Maio',
		'Junho',
		'Julho',
		'Agosto',
		'Setembro',
		'Outubro',
		'Novembro',
		'Dezembro',
	],
});

export default function cycleMonthOptions(
	selectedYear: number,
	cycle_id: number,
	cycles: ICycle[]
): IMonthOption[] {
	const cycle = cycles.find(cycle => cycle.id === cycle_id);
	if (cycle) {
		const type = 'months';
		const months = [] as IMonthOption[];
		for (let i = 0; i <= cycle.duracao - 1; i++) {
			const date = moment(cycle.data_inicio)
				.startOf('month')
				.add(i, type);
			months.push({
				label: date.locale('pt').locale('pt').format('MMMM'),
				value: date.format('YYYY-MM-DD'),
				month_number: Number(date.format('M')),
			} as IMonthOption);
		}
		return months;
	}
	return [];
}
